import { ButtonGroup, ButtonGroupProps } from '@chakra-ui/react';
import React from 'react';
import { segmentedStyles } from '@/views/sports/components/Segmented/styles/Segmented.styles';

export default function Segmented(props: ButtonGroupProps) {
  return <ButtonGroup {...props} {...segmentedStyles.segmentWrapper} />;
}
